import { GenericError } from '../GenericError';

export const XeroPayLinkError = () => {
  return (
    <>
      <GenericError errorText="it seems like something went wrong" />
    </>
  );
};
